module.exports = __webpack_public_path__ + "assets/img/one3.3df5c23d.png";